import React from "react";
import * as R from "ramda";

import { useLogin, useOutOfBand } from "./hooks";
import loginComponents from "./steps";

const Login = ({ initialState, onComplete, t, ...props }) => {
  const { onSubmit, loginState, maintenanceStatusErrors, outOfBand } = useLogin(
    {
      initialState,
      onComplete,
    }
  );

  const Component = loginComponents[loginState.state];

  if (!Component) {
    return null;
  }

  return (
    <Component
      key={loginState.state}
      onSubmit={onSubmit}
      loginState={loginState}
      outOfBand={outOfBand}
      formSuccessMessage={R.path(["location", "state", "formSuccessMessage"])(
        props
      )}
      errorMessages={maintenanceStatusErrors}
    />
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/Login.js